module.exports = __webpack_public_path__ + "content/6897d9d9662fb7333656d05146606b43.png";